var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 48,
    viewBox: "0 0 61 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5835 1.19871C47.2164 0.880879 50.8267 2.01921 53.6202 4.36328C56.4138 6.70735 58.1618 10.0651 58.4796 13.698C58.9685 19.2867 56.5325 24.9455 52.2828 26.3688C50.642 26.9189 49.4977 29.1848 49.9987 31.6128C50.6694 34.8617 53.9283 37.9193 60.0371 40.0199C61.3981 40.4881 61.0226 42.506 59.5848 42.4511C44.0931 41.8741 32.5972 32.814 31.3108 18.6849C30.4604 8.96452 35.6289 1.89465 43.5835 1.19871ZM13.6977 3.81338C17.3305 3.49555 20.9408 4.63388 23.7344 6.97795C26.528 9.32202 28.2759 12.6798 28.5937 16.3127C29.0827 21.9013 26.6466 27.5602 22.397 28.9835C20.7562 29.5336 19.6118 31.7994 20.1129 34.2275C20.7836 37.4764 24.0425 40.534 30.1513 42.6346C31.5123 43.1027 31.1367 45.1207 29.699 45.0658C14.2072 44.4888 2.71133 35.4287 1.425 21.2996C0.574574 11.5792 5.74306 4.50932 13.6977 3.81338Z",
    fill: "#744DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.ee6097fd50df752f8594cbc653e84fbf.svg";
export { ForwardRef as ReactComponent };